module.exports = __webpack_public_path__ + "img/ic_camera.4470da0f.svg";